import { z } from 'zod';

import { MileageSourceSchema } from './record-vehicle-mileage.schemas.js';

export const MileageRecorderKindSchema = z.enum(['WORKSHOP', 'CONSUMER']);
export type MileageRecorderKind = z.infer<typeof MileageRecorderKindSchema>;

export const VehicleMileageHistoryItemSchema = z.object({
  id: z.uuid(),
  mileageKm: z.number().nonnegative(),
  source: MileageSourceSchema,
  reason: z.string().nullable(),
  recordedAt: z.iso.datetime(),
  recordedByUserId: z.uuid().nullable(),
  recordedByConsumerId: z.uuid().nullable(),
  recordedByKind: MileageRecorderKindSchema,
  recordedByDisplayName: z.string().min(1).nullable(),
});

export type VehicleMileageHistoryItem = z.infer<typeof VehicleMileageHistoryItemSchema>;

export const ListVehicleMileageHistoryResponseSchema = z.object({
  items: z.array(VehicleMileageHistoryItemSchema),
});

export type ListVehicleMileageHistoryResponse = z.infer<
  typeof ListVehicleMileageHistoryResponseSchema
>;
